import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import PortfolioGrid from "@/components/PortfolioGrid";
import SocialBand from "@/components/SocialBand";
import CtaBand from "./home/CtaBand";
import { Reveal, SectionHeading } from "@/components/Reveal";
import api from "@/lib/api";

export default function Projects() {
  const [projects, setProjects] = useState(null);
  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data || [])).catch(() => setProjects([]));
  }, []);

  const featured = (projects || []).filter((p) => p.featured).slice(0, 9);

  return (
    <>
      <SEO
        title="Proiecte realizate — lucrări reale, rezultate reale | BROX CONSTRUCT"
        description="Proiecte reale Brox Construct: construcții, renovări și interioare, instalații și încălzire, șeminee și sobe, exterior și zidărie. Galerie foto cu lucrările noastre."
        path="/proiecte"
      />
      <section className="grain bg-ink-950 pb-12 pt-32 sm:pb-16 sm:pt-40">
        <div className="container-brox">
          <Reveal><p className="eyebrow mb-5">PORTOFOLIU</p></Reveal>
          <SectionHeading
            title={<>Proiecte realizate.<br /><span className="text-copper">Lucrări reale. Rezultate reale.</span></>}
          />
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg" data-testid="projects-copy">
              Portofoliul BROX CONSTRUCT este în continuă dezvoltare. Publicăm doar lucrări reale, documentate
              din șantier. Apasă pe un proiect pentru a vedea galeria foto completă.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ink-950 pb-16 sm:pb-20">
        <div className="container-brox">
          {projects === null && <div className="h-64" />}
          {projects !== null && featured.length > 0 && (
            <PortfolioGrid projects={featured} data-testid="portfolio-section" />
          )}
        </div>
      </section>

      <SocialBand
        title="Urmărește proiectele noastre"
        copy="Lucrările noi, pozele din timpul lucrărilor, transformările dinainte și după și proiectele finalizate sunt publicate și pe canalele noastre de social media."
      />
      <CtaBand />
    </>
  );
}
